import { DeviceConnectionStatus } from '@types';

type TranslationFunction = (key: string, fallback?: string) => string;

/**
 * Genera il tooltip label per un dispositivo VR
 */
export const getVrTooltipLabel = (
  status?: DeviceConnectionStatus,
  t?: TranslationFunction
): string => {
  if (status === 'connected' || status === 'receiving_data') {
    if (t) {
      return t('vr_connected_ready', "Visore connesso e pronto per l'uso");
    }
    return "Visore connesso e pronto per l'uso";
  }

  if (t) {
    return t(
      'vr_not_connected',
      'Visore non connesso. Verificare la connessione del dispositivo.'
    );
  }
  return 'Visore non connesso. Verificare la connessione del dispositivo.';
};

/**
 * Genera il tooltip label per un sensore/smartwatch
 */
export const getSensorTooltipLabel = (
  status?: DeviceConnectionStatus,
  t?: TranslationFunction
): string => {
  if (status === 'connected' || status === 'receiving_data') {
    if (t) {
      return t('sensor_connected_ready', "Sensore connesso e pronto per l'uso");
    }
    return "Sensore connesso e pronto per l'uso";
  }

  if (status === 'connected_no_data') {
    if (t) {
      return t(
        'sensor_connected_no_data',
        'Sensore connesso ma non riceve dati. Il dispositivo potrebbe essere in standby.'
      );
    }
    return 'Sensore connesso ma non riceve dati. Il dispositivo potrebbe essere in standby.';
  }

  if (t) {
    return t(
      'sensor_not_connected',
      'Sensore non connesso. Verificare la connessione del dispositivo.'
    );
  }
  return 'Sensore non connesso. Verificare la connessione del dispositivo.';
};

/**
 * Genera il tooltip label generico per un dispositivo
 */
export const getDeviceTooltipLabel = (
  deviceType: 'vr-headset' | 'smartwatch',
  status?: DeviceConnectionStatus,
  t?: TranslationFunction
): string => {
  if (deviceType === 'vr-headset') {
    return getVrTooltipLabel(status, t);
  }
  return getSensorTooltipLabel(status, t);
};
